import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a href="/" data-testid="brand-logo" className="font-heading text-lg font-black uppercase tracking-tight">
          Rocky <span className="text-[#FFD700]">Agency</span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" data-testid="main-nav">
          <a href="#variants" data-testid="nav-variants" className="text-xs font-medium uppercase tracking-[0.18em] text-[#A1A1A6] transition-colors duration-300 hover:text-white">
            Variants
          </a>
          <a href="#manifesto" data-testid="nav-manifesto" className="text-xs font-medium uppercase tracking-[0.18em] text-[#A1A1A6] transition-colors duration-300 hover:text-white">
            Manifesto
          </a>
          <a href="#gallery" data-testid="nav-gallery" className="text-xs font-medium uppercase tracking-[0.18em] text-[#A1A1A6] transition-colors duration-300 hover:text-white">
            Gallery
          </a>
          <Link
            to="/archive"
            data-testid="nav-archive"
            className="text-xs font-medium uppercase tracking-[0.18em] text-[#A1A1A6] transition-colors duration-300 hover:text-white"
          >
            Archive
          </Link>
        </nav>
        <Link
          to="/admin"
          data-testid="nav-admin-link"
          className="rounded-full border border-white/15 px-5 py-2 text-xs font-medium uppercase tracking-[0.15em] text-[#A1A1A6] transition-colors duration-300 hover:border-[#FFD700]/60 hover:text-[#FFD700]"
        >
          Admin
        </Link>
      </div>
    </header>
  );
}
